/* RK Threads — Win95 overlay
   - Marks the document with .win95-mode (CSS gate)
   - Injects a system-tray clock
   - Exposes window.RKThreadsWin95.crash() for the widget's Crash button
   - Handles BSOD + boot sequence + return-to-page */

(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    document.documentElement.classList.add("win95-mode");
    injectTray();
    pixelateLogo();
    exposeApi();
  });

  function injectTray() {
    if (document.querySelector(".w95-tray")) return;
    var tray = document.createElement("div");
    tray.className = "w95-tray";
    tray.innerHTML = '<span class="w95-tray__clock"></span>';
    document.body.appendChild(tray);
    var clock = tray.querySelector(".w95-tray__clock");
    function tick() {
      var d = new Date();
      var h = d.getHours();
      var m = d.getMinutes();
      var ampm = h >= 12 ? "PM" : "AM";
      h = h % 12 || 12;
      clock.textContent = h + ":" + (m < 10 ? "0" + m : m) + " " + ampm;
    }
    tick();
    setInterval(tick, 30000);
  }

  function exposeApi() {
    window.RKThreadsWin95 = {
      crash: triggerBsod,
    };
  }

  function triggerBsod() {
    if (document.querySelector(".w95-bsod")) return;
    var bsod = document.createElement("div");
    bsod.className = "w95-bsod";
    bsod.innerHTML =
      '<div class="w95-bsod__heading">RK_THREADS</div>\n' +
      "\nA fatal exception 0E has occurred at 0028:C0011E36 in VXD VMM(01) +\n" +
      "00010E36. The current application will be terminated.\n\n" +
      "*  Press any key to terminate the application.\n" +
      "*  Press CTRL+ALT+DEL again to restart your computer. You will\n" +
      "   lose any unsaved information in all applications.\n\n" +
      "Press any key to continue " +
      '<span class="w95-bsod__cursor"></span>\n\n' +
      '<button class="w95-bsod__restart" type="button">[ Restart ]</button>';
    document.body.appendChild(bsod);
    bsod.focus();

    function restart() {
      cleanup();
      bsod.remove();
      runBoot();
    }
    function cleanup() {
      document.removeEventListener("keydown", onKey, true);
    }
    function onKey(e) {
      e.preventDefault();
      restart();
    }
    document.addEventListener("keydown", onKey, true);
    bsod.querySelector(".w95-bsod__restart").addEventListener("click", restart);
  }

  function runBoot() {
    var bios = document.createElement("div");
    bios.className = "w95-boot";
    bios.textContent =
      "Award Modular BIOS v4.51PG, An Energy Star Ally\n" +
      "Copyright (C) 1984-95, Award Software, Inc.\n\n" +
      "RKTHREADS BIOS (2026)\n\n" +
      "Main Processor : Pentium(R) II 233MHz\n" +
      "Memory Testing : 65536K OK\n\n" +
      "Detecting IDE Primary Master ... HOODIE-2026\n" +
      "Detecting IDE Primary Slave  ... None\n\n" +
      "Press DEL to enter SETUP ...";
    document.body.appendChild(bios);

    setTimeout(function () {
      bios.remove();
      var splash = document.createElement("div");
      splash.className = "w95-boot w95-boot--splash";
      splash.innerHTML =
        '<div class="w95-boot__cloud">&#x2601;&#xFE0F;</div>' +
        "<div>Starting Windows 95...</div>";
      document.body.appendChild(splash);

      setTimeout(function () {
        splash.style.transition = "opacity 0.6s";
        splash.style.opacity = "0";
        setTimeout(function () {
          splash.remove();
        }, 700);
      }, 2200);
    }, 1800);
  }

  function pixelateLogo() {
    var selector =
      ".site-header__logo img, " +
      ".header__heading-logo img, " +
      'a[class*="logo-link"] img';
    var logoImgs = document.querySelectorAll(selector);
    logoImgs.forEach(function (originalImg) {
      if (originalImg.dataset.rk8bitDone) return;
      var probe = new Image();
      probe.crossOrigin = "anonymous";
      probe.onload = function () {
        try {
          var TARGET = 48;
          var ratio = probe.naturalHeight / probe.naturalWidth;
          var w = TARGET;
          var h = Math.max(1, Math.round(TARGET * ratio));
          var canvas = document.createElement("canvas");
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext("2d");
          ctx.imageSmoothingEnabled = false;
          ctx.drawImage(probe, 0, 0, w, h);
          var imgData = ctx.getImageData(0, 0, w, h);
          var d = imgData.data;
          for (var i = 0; i < d.length; i += 4) {
            d[i] = Math.round(d[i] / 64) * 64;
            d[i + 1] = Math.round(d[i + 1] / 64) * 64;
            d[i + 2] = Math.round(d[i + 2] / 64) * 64;
          }
          ctx.putImageData(imgData, 0, 0);
          originalImg.src = canvas.toDataURL("image/png");
          originalImg.setAttribute("data-rk-8bit", "true");
          originalImg.dataset.rk8bitDone = "1";
        } catch (e) {
          /* CORS-tainted canvas — leave the original logo alone */
        }
      };
      probe.src = originalImg.currentSrc || originalImg.src;
    });
  }
})();
